<template>
  <div class="bordered">
    <div class="container-fill" @click="toggle">
      <div>
        <strong>{{ subscription.type }}</strong> - {{ subscription.duration }}
      </div>              
        Exp : {{ subscription.expiration_date }}    
    </div>         

    <div class="details" v-show="isActive">
      <table>
        <tr>
          <td>New expiry date:</td>
          <td><input type="text" min="0" v-model="expiration_date"/></td>
        </tr>
        <tr v-show="subscription.type === 'continuous_testing'">
          <td>Continuous testing seats:</td>
          <td><input type="number" min="0" v-model="continuous_testing_seats"/></td>
        </tr>
      </table>
      <div>
        <button @click="cancel">Cancel</button>
        <button @click="save">Save</button>
        <button class="remove" @click="remove">Remove</button>
      </div>
    </div>

    <pre class="debug" v-show="debugMode">{{subscription}}</pre>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#profileButtons {
  display: inline-block;
  float: right;
}
.default {
  font-size: small;
}
.container {
  display: flex;
}
.container-fill {
  display: flex;
  justify-content: space-between;
}
.details {
  margin-top: 5px;
  border-top: 1px solid #cccccc;
  padding-top: 5px;
}
.details-header {
  font-size: small;
}
.details-header > h2,h3,h4 {
  font-size: initial;
  margin: 0px;
}
.remove {
  float: right;
}
</style>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    subscription: {
      type: Object,
      required: true
    },
    partner: {
      type: Object,
    }
  },
  computed: {
    ...mapState([
      'debugMode'
    ])
  },
  data () {
    return {             
          isActive: false,
          expiration_date: this.subscription.expiration_date,
          continuous_testing_seats: this.subscription.continuous_testing_seats
        }      
  },
  methods: {
    toggle: function (event) {
      if (event.target.tagName != 'DIV' && event.target.tagName != 'SPAN') return
      this.isActive = !this.isActive
    },
    cancel() {
      this.isActive = false
    },
    save () {
      // Collect only changed
      var params = {}
      // Expiration date
      if (this.expiration_date !== this.subscription.expiration_date)
        params['expiration_date'] = this.expiration_date
      // Continous testing seats
      if (this.continuous_testing_seats !== this.subscription.continuous_testing_seats) {
        params['continuous_testing_seats'] = (!this.continuous_testing_seats) ? -1 : this.continuous_testing_seats //enforce -1 when no seats are specified
      }
        // Return if nothing changed
      if (!Object.entries(params).length) return
      // Emit updated attributes
      this.$emit('update', {
        subscription: this.subscription,
        params: params
      })
    },
    remove() {
      this.$emit('remove', {
        subscription: this.subscription,
        partner: this.partner
      })
    }
  }
}
</script>
